import React, { useContext } from "react";
import { AppContext } from "../store/AppContext";
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Switch, 
  FormControlLabel, 
  Divider,
  Grid,
  Avatar,
  useTheme,
  useMediaQuery,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@mui/material';

const Profile = () => {
  const { state, dispatch } = useContext(AppContext);
  const { userDetails } = state;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className="page-container">
      <Typography variant="h4" className="page-title" gutterBottom>
        Profile
      </Typography>
      
      <Card sx={{ maxWidth: 800, mx: 'auto' }}>
        <CardContent>
          <Grid container spacing={3}>
            {/* Left Column - Avatar and Basic Info */}
            <Grid item xs={12} md={4}>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                textAlign: 'center'
              }}>
                <Avatar
                  sx={{
                    width: 120,
                    height: 120,
                    bgcolor: "#006BBB",
                    fontSize: '3rem',
                    mb: 2
                  }}
                >
                  {userDetails?.name?.charAt(0) || "U"}
                </Avatar>
                <Typography variant="h5" gutterBottom>
                  {userDetails?.name || "User"}
                </Typography>
                <Typography color="text.secondary">
                  {userDetails?.email}
                </Typography>
              </Box>
            </Grid>

            {/* Right Column - Preferences */}
            <Grid item xs={12} md={8}>
              <Box sx={{ pl: { md: 3 } }}>
                <Typography variant="h5" gutterBottom>
                  Preferences
                </Typography>
                
                <Grid container spacing={3}>
                  {/* Display Settings */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Display Settings
                    </Typography>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={state.theme === "dark"}
                          onChange={() => dispatch({ type: "TOGGLE_THEME" })}
                          color="primary"
                        />
                      }
                      label="Dark Mode"
                    />
                  </Grid>

                  {/* Evidence Handling Preferences */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Evidence Handling
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel>Default Hash Algorithm</InputLabel>
                          <Select
                            defaultValue="sha256"
                            label="Default Hash Algorithm"
                          >
                            <MenuItem value="md5">MD5</MenuItem>
                            <MenuItem value="sha1">SHA-1</MenuItem>
                            <MenuItem value="sha256">SHA-256</MenuItem>
                            <MenuItem value="sha512">SHA-512</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel>Default Evidence Format</InputLabel>
                          <Select
                            defaultValue="raw"
                            label="Default Evidence Format"
                          >
                            <MenuItem value="raw">Raw Image</MenuItem>
                            <MenuItem value="aff">AFF</MenuItem>
                            <MenuItem value="ewf">EWF</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Notification Preferences */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Notifications
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={<Switch defaultChecked />}
                          label="Email notifications for evidence processing completion"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={<Switch defaultChecked />}
                          label="Browser notifications for new evidence uploads"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={<Switch />}
                          label="Weekly usage summary reports"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Security Preferences */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Security
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={<Switch defaultChecked />}
                          label="Require 2FA for evidence downloads"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={<Switch defaultChecked />}
                          label="Auto-lock evidence viewer after 30 minutes of inactivity"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default Profile;
